import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	getCategoryObjects,
	getCategoryObjectsEndpoint,
	type QueryError,
	type GetCategoryObjectsResult,
	type GetCategoryObjectsRequestOptions,
} from '@netx/core-category/api/getCategoryObjects';

export type GetCategoryObjectsQueryParams = GetCategoryObjectsRequestOptions;
export type GetCategoryObjectsQueryKey = [
	string,
	GetCategoryObjectsQueryParams,
];

export type GetCategoryObjectsQueryOptions = Omit<
	UseQueryOptions<
		GetCategoryObjectsResult,
		QueryError,
		GetCategoryObjectsResult,
		GetCategoryObjectsQueryKey
	>,
	'queryKey' | 'queryFn'
>;

/**
 * react-query wrapper for `getCategoryObjects`
 * @param queryKeyParams
 * @param options
 */
export const reactQueryGetCategoryObjects = (
	queryKeyParams: GetCategoryObjectsQueryParams,
	options?: GetCategoryObjectsQueryOptions,
) =>
	useQuery<
		GetCategoryObjectsResult,
		QueryError,
		GetCategoryObjectsResult,
		GetCategoryObjectsQueryKey
	>({
		queryKey: [getCategoryObjectsEndpoint, queryKeyParams],
		queryFn: ({queryKey, signal}) => getCategoryObjects(queryKey[1], signal),
		enabled: !!queryKeyParams.ids.length,
		...options,
	});

export default reactQueryGetCategoryObjects;
